import _ from 'lodash'
import { routeBookingConstants, routeBookingConstantValues } from 'utils/constants/route/RouteBookingConstants'
import { AppRoutes } from 'navigations/app-routes'
import ObjectFloor from 'utils/objects/floor'
import ObjectClass from 'utils/objects/object'
import ObjectRoom from 'utils/objects/room'

export const ungroupForcedTimeslotsFromForcedGuids = ( forcedGuids ) => {
	forcedGuids = { ...forcedGuids };
	if( forcedGuids[ routeBookingConstants.FORCED_TIMESLOTS ] ){
		_.forEach( forcedGuids[ routeBookingConstants.FORCED_TIMESLOTS ], ( forcedTimeslot, index ) => {
			forcedGuids[ routeBookingConstants[ `FORCED_TIMESLOT_${index+1}`] ] = forcedTimeslot;
		});
		
		delete forcedGuids[ routeBookingConstants.FORCED_TIMESLOTS ];
	}
	
	return forcedGuids;
}

export const getNextLocationRoute = ( routeParams, location = null ) => {
	const currentDepthLevel = _.get( routeParams, routeBookingConstants.DEPTH_LEVEL, null );
	
	routeParams = {
		...routeParams,
		[routeBookingConstants.BUILDING]: _.get( routeParams, routeBookingConstants.BUILDING, null ),
		[routeBookingConstants.FLOOR]: _.get( routeParams, routeBookingConstants.FLOOR, null ),
		[routeBookingConstants.ROOM]: _.get( routeParams, routeBookingConstants.ROOM, null ),
		[routeBookingConstants.DEPTH_LEVEL]: routeBookingConstantValues[ routeBookingConstants.DEPTH_LEVEL ].BUILDING
	};
	
	let routeLocation = AppRoutes.ADD_BOOKING_LOCATION;
	if( location !== null ) {
		switch( currentDepthLevel ) {
			// From a Building
			case routeBookingConstantValues[ routeBookingConstants.DEPTH_LEVEL ].BUILDING:
				return getBuildingLocationRoute( routeParams, location );
				
			case routeBookingConstantValues[ routeBookingConstants.DEPTH_LEVEL ].FLOOR:
				return getFloorLocationRoute( routeParams, location );
				
			case routeBookingConstantValues[ routeBookingConstants.DEPTH_LEVEL ].ROOM:
				return getRoomLocationRoute( routeParams, location );
		}
	}
	
	return { routeLocation, routeParams };
}

const getBuildingLocationRoute = ( routeParams, building ) => {
	const floors = ObjectFloor.filterAndOrder( ObjectClass.filterActive( ObjectFloor.get( building.floors ) ) );
	
	routeParams[ routeBookingConstants.BUILDING ] = building.guid;
	
	let routeLocation = null;
	
	// Force the rooms from the tree to the floor :)
	//_.forEach( floors, floor => {
	//	const buildingFloorRooms = _.get( building, ['floors', floor.guid ], {} )
	//
	//	floor.rooms = buildingFloorRooms?.rooms ?? {}
	//})
	
	switch( true ){
		case _.isEmpty( floors ) : // no floors, goto booking
			routeLocation = AppRoutes.ADD_BOOKING_DATE;
			break;
			
		case _.size( floors ) > 1: // many floors, offer selection
		//case _.size( building.timeslots_through ) > 0:
			routeParams[ routeBookingConstants.DEPTH_LEVEL ] = routeBookingConstantValues[ routeBookingConstants.DEPTH_LEVEL ].FLOOR;
			routeLocation = AppRoutes.ADD_BOOKING_LOCATION_2;
			break;
			
		case _.size( floors ) === 1: // single room, get the proper route (might skip to room)
			return getFloorLocationRoute( routeParams, floors[ 0 ] );
			
		default: // uuuuuh
			console.prefix( 'HENK getBuildingLocationRoute', 'not captured!' );
	}
	
	return {routeLocation, routeParams };
}

const getFloorLocationRoute = ( routeParams, floor ) => {
	const rooms = ObjectRoom.filterAndOrder( ObjectClass.filterActive( ObjectRoom.get( floor.rooms ) ) );
	
	routeParams[ routeBookingConstants.FLOOR ] = floor.guid;
	
	let routeLocation = null;
	
	switch( true ) {
		case _.isEmpty( rooms ) : // no rooms, goto booking
			routeLocation = AppRoutes.ADD_BOOKING_DATE;
			break;
			
		case _.size( rooms ) > 1: // many rooms, offer selection
			routeParams[ routeBookingConstants.DEPTH_LEVEL ] = routeBookingConstantValues[ routeBookingConstants.DEPTH_LEVEL ].ROOM;
			routeLocation = AppRoutes.ADD_BOOKING_LOCATION_3;
			break;
			
		case _.size( rooms ) === 1: // one room, get the proper route
			return getRoomLocationRoute( routeParams, rooms[ 0 ] );
			
		default: // uuuuh
			console.prefix( 'HENK getFloorLocationRoute', 'not captured!' );
	}
	
	return {routeLocation, routeParams };
}

const getRoomLocationRoute = ( routeParams, room ) => {
	let routeLocation = AppRoutes.ADD_BOOKING_DATE;
	routeParams[ routeBookingConstants.ROOM ] = room.guid;
	return {routeLocation, routeParams };
}
